import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import type {
  CreateFeatureFlagRequest,
  ListFeatureFlagFilters as ListFeatureFlagFiltersType,
  UpdateFeatureFlagRequestMutation,
} from '@vendasta/protos/partner/v1/types';
import {
  batchGetStatus$,
  batchGet$,
  update$,
  create$,
  list$,
  createAnalyticsDashboard$,
} from '@vendasta/protos/partner/v1/feature-flags';

export interface FeatureFlagStatusInterface {
  [status: string]: boolean;
}

export interface ListFeatureFlagFilters extends Partial<ListFeatureFlagFiltersType> {
  archivedOnly?: boolean;
}

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  batchGetStatus(partnerId: string, marketId: string, featureIds: string[]) {
    return batchGetStatus$({ featureIds, partnerId, marketId }).pipe(
      map((resp): FeatureFlagStatusInterface => {
        const statuses: FeatureFlagStatusInterface = {};
        resp.hasAccess.forEach((status, i) => {
          statuses[featureIds[i]] = status;
        });
        return statuses;
      }),
    );
  }

  batchGet(featureFlagIds: string[]) {
    return batchGet$({ ids: featureFlagIds }).pipe(map((resp) => resp.flags));
  }

  update(id: string, mutations: Partial<UpdateFeatureFlagRequestMutation>[]) {
    return update$({ id, mutations }).pipe(map(() => true));
  }

  create(featureFlag: Partial<CreateFeatureFlagRequest>) {
    return create$(featureFlag).pipe(map(() => true));
  }

  list(cursor: string, pageSize: number, filters: ListFeatureFlagFilters) {
    return list$({
      archivedOnly: filters.archivedOnly,
      cursor,
      pageSize,
      filters: { searchTerm: filters.searchTerm ?? '', accessLevel: filters.accessLevel ?? [] },
    });
  }

  createAnalyticsDashboard(featureFlagID: string, userID: string) {
    return createAnalyticsDashboard$({ featureFlagId: featureFlagID, userId: userID }).pipe(map(() => true));
  }
}
